export  const getAddressViaCep = async (cep: string) => {
    try {
        const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
        const data = await response.json();

        if (!data.erro) {
          return data;
        } else {
          console.error("CEP não encontrado");
        }
      } 
      catch (error) {
        console.error("Erro ao buscar o CEP", error);
      }
    }
